import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const CTAModifiedBGStyles = styled.div`
  /* This supplmental BG styling is used in 3 places: 
        -About (src\components\About\About.js)
        -Sustainability (src\components\About\Sustainability\Sustainability.js)
        -LocationsStateListingStyles (src\components\Locations\LocationsStateListing.js)
    
        Usually, the background image selected matches the background color and text looks good with text over it (example: Get Inspired). 
        However, sometimes an image with darker colors on it is used and we need to stack the image and text, instead of 
        putting them on top of one another. This happens only in mobile
        
    */

  .cta {
    > div {
      background-size: 30%;
      background-position: 95%;
    }
  }
  @media screen and (max-width: ${desktop_breakpoint}px) {
    .cta {
      > div {
        background-position-x: center;
        background-position-y: 10px;
        background-size: 180px;

        .cta-inside {
          padding-top: 180px;

          .cta-heading,
          .custom-category,
          .cta-text,
          .cta-buttons {
            margin-left: auto;
            margin-right: auto;
            text-align: center;
          }
        }
      }
    }
  }
`;
